import Vue from 'vue';
import Vuex from 'vuex';
import service from '../api/api.js';

Vue.use(Vuex)

let store = new Vuex.Store({
    state: {
        date: new Date(),
        config: null,
    },
    getters: {
        date(state) {
            return state.date;
        },
        config(state) {
            return state.config;
        }
    },
    mutations: {},
    actions: {
        ...service,
        setDate(store, date) {
            store.state.date = date;
        },
        setLocalConfig(store, config) {
            store.state.config = config;
        }
    },
    modules: {}
});

setInterval(_ => {
    store.dispatch('setDate', new Date());
}, 1000);

export default store;
